import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    background: '#FFFFFF',
    border: '1px solid #DEDEDE',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    padding: '20px 16px',
    fontFamily: theme.typography.fontFamily,
  },
})
export default styleOverride
